






























interface DelIds {
    check: boolean;
    customer: string;
    id: string | number;
    invoiceNo: string;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";

import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class ChangePeriod extends Vue {
    @Prop({ type: Array })
    delIds?: DelIds[];

    invoiceList: DelIds[] = []
    period: Date | string = "";
    closePeriod: Date = new Date()
    pickerOptions: DatePickerOptions = {};
    mounted() {
        if (this.$store.state.accountBook.closePeriod != null) {
            let p = this.$store.state.accountBook.closePeriod;
            this.closePeriod = new Date(p.substr(0, 4) + "-" + p.substr(4));
        } else {
            let p = this.$store.state.accountBook.startPeriod;
            this.closePeriod = this.$utils.dateAdd(new Date(p.substr(0, 4) + "-" + p.substr(4)), "m", -1);
        }
        this.pickerOptions = {
            disabledDate: time => {
                return time.getTime() < this.$utils.dateAdd(this.closePeriod, "m", 1).getTime()
            }
        };
        if (this.delIds) {
            for (let i = 0; i < this.delIds.length; i++) {
                if (this.delIds[i].check) this.invoiceList.push(this.delIds[i])
            }
        }
    }

    save() {
        if (this.period === "") {
            this.$message.warning("请选择新的票据期间！");
        } else {
            let ids = "";
            this.invoiceList.forEach((v: DelIds, i: number) => {
                if (i != this.invoiceList.length - 1) ids += v.id + ",";
                else ids += v.id;
            })
            let period = this.$utils.simpleDateFormat(<Date>this.period, "m");
            Vue.axios
                .post(`invoice/update/period?id=${ids}&period=${period}`)
                .then(res => {
                    this.$emit("success", true)
                });
        }
    }
    close() {
        this.$emit("success", false)
    }
    // 删除列表项
    handleClose(tag:DelIds) {
        if (this.invoiceList) {
            for (let i = 0; i < this.invoiceList.length; i++) {
                if (this.invoiceList[i].id == tag.id) {
                    this.invoiceList.splice(i, 1);
                }
            }
            if (this.invoiceList.length == 0) {
                this.close();
            }
        }
    }

}
